module.exports = __webpack_public_path__ + "img/practicalCertificate.7673533b.png";